import React, { useState, useEffect } from "react";
import carToTop from "../assets/car-to-top.png";
import { scrollToTop } from "./scrollHelpers";
const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Toggle visibility of the button
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <button className="goToTop" onClick={scrollToTop}>
          <img
            src={carToTop}
            alt="top"
            width="40px"
            style={{ backgroundColor: "white" }}
          />
        </button>
      )}
    </div>
  );
};

export default GoToTop;
